// Add modules HERE!!!
import auth from '@/pages/auth/store';
import dashboard from '@/pages/dashboard/store';
import estudantes from '@/pages/estudantes/store';

export default {
  auth,
  dashboard,
  estudantes,
}



// WEBPACK FOOTER //
// ./src/store/modules.js